<template>
  <div
    class="modifier-groups__group"
    :class="{
      'modifier-groups__group--invalid': errorMessage
    }"
  >
    <select-input
      v-model="selection"
      class="select-input--inline"
      :label="label"
      :name="name"
      :searchable="false"
      :values="options"
      :validations="{
        required: modifierGroup.minRequired > 0
      }"
    />
  </div>
</template>



<script>
  import { useFieldError } from 'vee-validate';

  export default {
    name: 'ModifierSelectGroup',

    inject: {
      validatedForm: {
        from: 'validatedForm'
      }
    },

    props: {
      hidePrices: {
        type: Boolean,
        default: false
      },
      label: {
        type: String,
        required: true
      },
      modifierGroup: {
        type: Object,
        required: true
      },
      name: {
        type: String,
        required: true
      },
      selectedModifiers: {
        type: Array,
        default: null
      }
    },

    setup(props) {
      const errorMessage = useFieldError(() => props.name);

      return { errorMessage };
    },

    data() {
      return {
        selection: null,
        quantity: 1
      };
    },

    computed: {
      options: {
        get() {
          return this.modifierGroup.modifiers.map(m => ({
            display: m.displayName,
            price: this.hidePrices ? null : m.price,
            value: m.menuItemId
          }));
        }
      }
    },

    watch: {
      selection: {
        handler: 'selectionChangeHandler'
      }
    },

    created() {
      this.parseModifierGroup();
    },

    methods: {
      selectionChangeHandler(value) {
        const modifiers = [];

        if (value) {
          modifiers.push({
            menuItemId: value,
            quantity: this.quantity
          });
        }

        this.$emit('selected', {
          modifierGroupId: this.modifierGroup.modifierGroupId,
          modifiers
        });
      },

      parseModifierGroup() {
        const defaultModifier = this.modifierGroup.modifiers.find(modifier => modifier.isDefault);

        if (this.selectedModifiers) {
          let selection;

          this.modifierGroup.modifiers.forEach((modifier) => {
            selection = this.selectedModifiers.find(m => m.menuItemId === modifier.menuItemId);
          });

          if (selection) {
            this.selection = selection.menuItemId;
            this.quantity = selection.quantity;
          }
        }

        else if (defaultModifier) {
          this.selection = defaultModifier.menuItemId;
        }
      }
    }
  };
</script>
